import { useCallback, useEffect, useState } from 'react';

export const useIOSFullscreen = (element) => {
    const [ isFullscreen, setFullscreen ] = useState<boolean>(false);

    useEffect(() => {
        if (!element) { return; }
        if (isFullscreen) {
            element.style.position = 'fixed';
            element.style.zIndex = '99999';
            element.style.border = 'none';
            element.style.borderRadius = 0;
            element.style.background = 'black';
        } else {
            element.style.position = '';
            element.style.zIndex = '';
            element.style.border = '';
            element.style.borderRadius = '';
            element.style.background = '';
        }
    }, [isFullscreen, element]);

    const toggleFullscreen = useCallback(() => {
        setFullscreen((isFullscreen) => !isFullscreen);
    }, [element])

    return {
        isFullscreen,
        toggleFullscreen
    }
}
